export default __webpack_public_path__ + "static/media/booking-notification.a3dd13b6.wav";